<template>
  <v-row>
    <v-col cols="12" class="historic-quotation__container">
      <v-row class="pa-5">
        <v-col cols="auto" class="align-self-center px-4">
          <p class="font-weight-bold mb-0 primary--text">
            {{ item.numero }} - {{ item.seguradora.nome }}
          </p>
        </v-col>
        <v-spacer />
        <v-col cols="auto" class="px-4">
          <BaseButton icon @click="showItem()">
            <v-icon color="primary" size="14"> {{ iconShowItem }} </v-icon>
          </BaseButton>
        </v-col>
      </v-row>
      <v-row class="px-5 pb-3" v-if="visibleItem">
        <v-col cols="12">
          <div v-for="(element, key) in list" :key="key" class="pb-2">
            <v-row class="white py-5 px-4" v-if="item[element.type]">
              <v-col
                cols="12"
                sm="5"
                class="justify-center d-flex justify-sm-start"
              >
                <p class="primary--text font-weight-bold body-1 mb-sm-0">
                  {{ element.title }}
                </p>
              </v-col>
              <v-col
                cols="12"
                sm="auto"
                class="justify-center d-flex justify-sm-start"
              >
                <p class="gray--text body-2 mb-sm-0">
                  {{ item[element.type].nome }}
                  <v-tooltip bottom content-class="tooltip-historical">
                    <template v-slot:activator="{ on }">
                      <v-icon
                        color="secondary"
                        size="10"
                        v-on="on"
                        class="pl-1"
                      >
                        fa-info-circle
                      </v-icon>
                    </template>
                    <v-row>
                      <v-col cols="12" class="px-4 py-3">
                        <p
                          class="white--text tooltip-label-text mb-0"
                          style="white-space: pre-line"
                        >
                          Email: {{ item[element.type].email }} Telefone:
                          {{ item[element.type].telefone }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-tooltip>
                </p>
              </v-col>
              <v-spacer />
              <v-col
                cols="12"
                sm="auto"
                class="justify-center d-flex justify-sm-start"
              >
                <p class="gray--text body-2 mb-sm-0" v-if="item[element.date]">
                  {{ formatIsoDateToDDMMYYYYHHMM(item[element.date]) }}
                </p>
              </v-col>
              <v-spacer />
              <v-col
                cols="12"
                sm="auto"
                class="justify-center d-flex justify-sm-start"
              >
                <BaseButton
                  color="secondary"
                  class="historic-quotation__button px-0"
                  @click="previewItem(item)"
                  v-if="element.type == 'aprovada_por'"
                >
                  <img src="@/assets/ic_eye.svg" :alt="item.url" />
                </BaseButton>
                <div class="historic-quotation__button" v-else />
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
const MOCK_ITEMS = [
  {
    type: "solicitada_por",
    title: "Minuta solicitada por",
    date: "solicitada_em"
  },
  {
    type: "recusada_por",
    title: "Minuta recusada por",
    date: "recusada_em"
  },
  {
    type: "declinada_por",
    title: "Minuta declinada por",
    date: "declinada_em"
  },
  {
    type: "aprovada_por",
    title: "Minuta aprovada por",
    date: "aprovada_em"
  }
];
import { formatIsoDateToDDMMYYYYHHMM } from "@/utils/formats.js";
export default {
  data: () => ({
    visibleItem: false,
    list: MOCK_ITEMS,
    formatIsoDateToDDMMYYYYHHMM
  }),
  computed: {
    iconShowItem() {
      return this.visibleItem ? "fa-chevron-up" : "fa-chevron-down";
    }
  },
  methods: {
    showItem() {
      this.visibleItem = !this.visibleItem;
    },
    previewItem(item) {
      window.open(item.arquivo.url);
    }
  },
  props: {
    item: {
      type: Object
    }
  }
};
</script>
<style lang="sass">
.historic-quotation__
  &container
    border: 1px solid #D5D5E0
    border-radius: 2px
    background-color: #F0F0F7
  &button
    min-width: 40px !important
</style>
